<button *ngIf="minimal" class="layout-config-button p-link" type="button" (click)="open()" aria-label="Appearance">
    <i class="pi pi-palette"></i>
</button>

<p-sidebar [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0.2, 0.7, 0.2, 1)'"
    styleClass="layout-config-sidebar fz-appearance" ariaCloseLabel="Close appearance">
    <h4 class="fz-appearance-title">Appearance</h4>
    <p class="fz-appearance-lede">Your choice is saved on this device.</p>

    <ng-container *ngTemplateOutlet="group; context: { $implicit: lightThemes, title: 'Light' }"></ng-container>
    <ng-container *ngTemplateOutlet="group; context: { $implicit: darkThemes, title: 'Dark' }"></ng-container>

    <ng-template #group let-themes let-title="title">
        <h5 class="fz-appearance-group">{{ title }}</h5>
        <div class="fz-theme-grid" role="radiogroup" [attr.aria-label]="title + ' themes'">
            <button *ngFor="let t of themes" type="button" class="fz-theme-option" role="radio"
                [attr.aria-checked]="t.id === layoutService.themeId" [class.is-active]="t.id === layoutService.themeId"
                (click)="pick(t.id)">
                <!-- A tiny page in the theme: ground, a card on it, and the accent -->
                <span class="fz-theme-preview" [style.background]="t.swatch[0]" aria-hidden="true">
                    <span class="fz-theme-preview-rail" [style.background]="t.swatch[1]"></span>
                    <span class="fz-theme-preview-card" [style.background]="t.swatch[1]">
                        <span [style.background]="t.swatch[2]"></span>
                    </span>
                </span>
                <span class="fz-theme-name">
                    {{ t.label }}
                    <i *ngIf="t.id === layoutService.themeId" class="pi pi-check" aria-hidden="true"></i>
                </span>
            </button>
        </div>
    </ng-template>

    <h5 class="fz-appearance-group">Text size</h5>
    <div class="fz-scale" role="radiogroup" aria-label="Text size">
        <button *ngFor="let s of scales" type="button" role="radio" [attr.aria-checked]="s === scale"
            [class.is-active]="s === scale" (click)="setScale(s)" [style.font-size.px]="s"
            [attr.aria-label]="s + ' pixels'">Aa</button>
    </div>
</p-sidebar>
